// Shared copy for the 50-State Business Entity Search Directory.
// Keeping the exact spec wording in one place so it can't drift.

export const CONSUMER_NOTICE = `Use the organization's exact legal name when recording your information. Business-search results may not establish which party is legally responsible or where legal documents must be served. Confirm important information with the official agency, court, or a licensed attorney.`;

export const IMPORT_CONFIRMATION = `I reviewed this information using the official state business database and understand that ProSe.Claims has not determined whether this is the correct party or service address.`;

export const STATUS_LABEL = {
  active: "Active",
  redirected: "Redirected",
  broken: "Broken",
  pending_review: "Pending review",
};

export const STATUS_TONE = {
  active: "text-emerald-700 bg-emerald-50 border-emerald-200",
  redirected: "text-amber-700 bg-amber-50 border-amber-200",
  broken: "text-red-700 bg-red-50 border-red-200",
  pending_review: "text-slate-600 bg-slate-50 border-slate-200",
};

export const CONFIRMATION_STATUS = [
  { value: "confirmed", label: "Confirmed" },
  { value: "uncertain", label: "Uncertain" },
  { value: "disputed", label: "Needs review" },
];
